/*
 *
 * Artifactory is a binaries repository manager.
 * Copyright (C) 2018 JFrog Ltd.
 *
 * Artifactory is free software: you can redistribute it and/or modify
 * it under the terms of the GNU Affero General Public License as published by
 * the Free Software Foundation, either version 3 of the License, or
 *  (at your option) any later version.
 *
 * Artifactory is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 * GNU Affero General Public License for more details.
 *
 * You should have received a copy of the GNU Affero General Public License
 * along with Artifactory.  If not, see <http://www.gnu.org/licenses/>.
 *
 */
export function recursiveDirective($compile) {
	return {
		compile: (elem, link) => {
            link = _.isFunction(link) ? { post: link } : link;
			var origContents = elem.contents().remove();
			var compileFunction;
			return {
				pre: (link && link.pre) ? link.pre : null,
				post: (scope, elem) => {
                    compileFunction = !compileFunction ? $compile(origContents) : compileFunction;
					compileFunction(scope, (clone) => elem.append(clone));
					if (link && link.post) link.post.apply(null, arguments);
				}
			};
		}
	};
}



// WEBPACK FOOTER //
// ./services/recursive_directive.js